import {
  MeResponse,
  CreateVoiceServiceTokenResponse,
  isClassCodeValidResponse,
} from '@/types/response';
import { AuthService } from '@/types/services';

import config from '@/config';
import axiosInstance from '@/utils/api-new';

export const authService: AuthService = {
  me: async userId => {
    const isLogIn = Boolean((window as any).userDataIsLogIn).toString();
    (window as any).userDataIsLogIn = false;

    const googleToken = localStorage.getItem('X-google-token');
    const provider =
      googleToken && googleToken !== 'undefined' && googleToken !== 'null'
        ? '&provider=google'
        : '';
    const resp: MeResponse | null = await axiosInstance.get(
      `${config.apiVersion}/user-data/${userId}?isLogin=${isLogIn}${provider}`
    );
    return resp;
  },
  createVoiceServiceToken: async (userId: string) => {
    const resp: CreateVoiceServiceTokenResponse | null = await axiosInstance.get(
      `${config.apiVersion}/voice-service-token/${userId}`
    );
    return resp;
  },
  isClassCodeValid: async (classCode: string) => {
    const resp: isClassCodeValidResponse | null = await axiosInstance.get(
      `${config.apiVersion}/is-class-code-valid/${classCode}`
    );

    return resp;
  },
};
